// extracted by mini-css-extract-plugin
export default {"signature":"DashboardOverview_signature__AizJs"};